import * as React from "react";
import "./buttonGroupWrapper.scss";

const classNames = require("classnames");

interface IProps {
	/**
	 * Place wrapper on the right side of the header.
	 */
	isRight?: boolean;
}

export default class ButtonGroupWrapper extends React.Component<IProps, {}> {
	render() {
		const classes = classNames({
			"c-group-wrapper": true,
			"c-group-wrapper_right": this.props.isRight
		});
		return (
			<div className={classes}>
				{this.props.children}
			</div>
		);
	}
}